import React from 'react';
import { CommonDeleteModal } from 'components/common';
import { useDeleteModal } from './useDeleteModal';

interface DeleteModal {
  openModal: boolean;
  dataToDelete: string | undefined;
  onDeleteModalClose: () => void;
}

export const DeleteModal = (props: DeleteModal) => {
  const { openModal, onDeleteModalClose, dataToDelete } = props;
  const { onRemoveConfirm, isLoading, onCancel } = useDeleteModal(onDeleteModalClose);
  return (
    <CommonDeleteModal
      onCancel={onCancel}
      open={openModal}
      isLoading={isLoading}
      onOk={() => onRemoveConfirm(dataToDelete)}
      onClose={onCancel}
      title={'Delete Note'}
      message={'Are you sure you want to delete this note?'}
    />
  );
};
